export default function Footer() {
  return (
    <footer
      className=" relative w-full overflow-hidden bg-[#020617] text-slate-300 border-t border-indigo-500/20 ">
      {/* Subtle genome glow */}
      <div
        className=" pointer-events-none absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(34,211,238,0.14),transparent_50%), radial-gradient(circle_at_bottom_right,rgba(168,85,247,0.12),transparent_55%)]"/>

      {/* ===== Main Content ===== */}
      <div
        className=" relative mx-auto max-w-7xl px-6 py-10 grid grid-cols-1 md:grid-cols-3 gap-10 ">
        {/* ================= BRAND / ABOUT ================= */}
        <div className="space-y-3">
          <h3
            className=" text-lg font-extrabold tracking-tight bg-gradient-to-r from-cyan-400 via-indigo-400 to-purple-400 bg-clip-text text-transparent ">
            CompuBio
          </h3>

          <p className="text-sm text-indigo-200/70 leading-relaxed max-w-md">
            AI-powered bioinformatics platform for genomics and microbiome
            analysis, designed for reproducible pipelines, scalable workflows,
            and confident scientific decisions.
          </p>

          <p className="text-xs text-indigo-300/50">
            Genome Intelligence · AI · Cloud Bioinformatics
          </p>
        </div>

        {/* ================= LINKS ================= */}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-cyan-400 mb-4">
            Platform
          </h4>

          <ul className="space-y-2 text-sm">
            {[
              { href: "/dashboard", label: "Dashboard" },
              { href: "/pricing", label: "Pricing & Plans" },
              { href: "/docs", label: "Documentation & APIs" },
              { href: "/about", label: "About CompuBio" },
            ].map((item) => (
              <li key={item.href}>
                <a
                  href={item.href}
                  className=" text-indigo-200/70 hover:text-cyan-400 transition ">
                  {item.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        {/* ================= CONTACT / INFO ================= */}
        <div>
          <h4 className="text-xs font-bold uppercase tracking-widest text-cyan-400 mb-4">
            Contact
          </h4>

          <ul className="space-y-2 text-sm text-indigo-200/70">
            <li>
              <a
                href="mailto:info@compubio.ca"
                className="hover:text-cyan-400 transition"
              >
                info@compubio.ca
              </a>
            </li>
            <li>
              <a
                href="tel:+14163188414"
                className="hover:text-cyan-400 transition"
              >
                +1 (416) 318-8414
              </a>
            </li>
            <li className="text-xs text-indigo-300/50 pt-2">
              Built for researchers, clinicians, and biotech teams operating at
              scientific scale.
            </li>
          </ul>
        </div>
      </div>

      {/* ===== Bottom Bar ===== */}
      <div
        className=" relative border-t border-indigo-500/20 py-3 text-center text-[11px] text-indigo-300/60 ">
        © {new Date().getFullYear()} CompuBio Science Solutions · All rights reserved.
      </div>
    </footer>
  );
}
